"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCancellationVoidStateSchema = exports.orderCancellationEnvelopeSchema = exports.orderCancellationDocumentSchema = exports.ENVELOPE_VOID_NOTHING_TO_RETRY_MESSAGE = exports.ENVELOPE_VOID_FAILED_LABEL = void 0;
const zod_1 = require("zod");
const order_document_types_1 = require("../documents/order-document-types");
const orders_1 = require("./orders");
// What the operator reads on a cancelled order when voiding the envelope at the
// signing provider did not go through. The cancel itself stands — every Foundry
// write of it committed — so this is a follow-up, not a failure of the cancel.
exports.ENVELOPE_VOID_FAILED_LABEL = 'envelope void failed';
// Refused when no envelope on the order is in the failed state. Retrying a void
// that never failed would call the provider for nothing.
exports.ENVELOPE_VOID_NOTHING_TO_RETRY_MESSAGE = 'No envelope void on this order needs retrying.';
// A purchase order or sales order of the order, with the status the void left
// it in. `voided` is terminal.
exports.orderCancellationDocumentSchema = zod_1.z.object({
    document_id: zod_1.z.string().uuid(),
    document_type: order_document_types_1.orderDocumentTypeSchema,
    status: zod_1.z.string(),
    voided: zod_1.z.boolean(),
});
// One signing envelope of the order. `status` is the provider's state, which
// only reaches `voided` once the provider confirms the void; `void_failed` is
// the separate Foundry-side record of a void attempt that did not.
exports.orderCancellationEnvelopeSchema = zod_1.z.object({
    signature_id: zod_1.z.string().uuid(),
    document_type: zod_1.z.string(),
    status: zod_1.z.enum(orders_1.SIGNATURE_STATUSES).nullable(),
    void_failed: zod_1.z.boolean(),
    void_failed_at: zod_1.z.string().nullable(),
    void_error: zod_1.z.string().nullable(),
});
exports.orderCancellationVoidStateSchema = zod_1.z.object({
    order_id: zod_1.z.string(),
    documents: zod_1.z.array(exports.orderCancellationDocumentSchema),
    envelopes: zod_1.z.array(exports.orderCancellationEnvelopeSchema),
    // True when at least one envelope is in the failed state — the one value the
    // Retry action keys on.
    envelope_void_failed: zod_1.z.boolean(),
});
//# sourceMappingURL=order-cancellation-documents.js.map